module.exports = __webpack_public_path__ + "img/header-weddingRingsBlack.397c7d3.jpg";